import React from "react";
import styled from "@emotion/styled";
// import icon from "../images/icon.png";
import icon from "../images/icon.jpeg";
const SystemMessage = ({ text }) => {
  return (
    <>
    {/* if text striped is not empty the display avatar */}
    { 
      (text.trim() !== "") ?(
    <StyledSystemMessage>
      <AvatarWrapper>
        <img alt="avatar" src={icon} />
      </AvatarWrapper>

      <Message>{text}</Message>
    </StyledSystemMessage>
    ) : (null)
    }
    </>
  );
};

const StyledSystemMessage = styled.div`
  display: flex;
  gap: 10px;
`;

const AvatarWrapper = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  transform: translateY(-6px);
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Message = styled.p`
  font-size: 14px;
  color: rgba(17, 17, 17, 1);
  max-width: 286px;
  line-height: 18px;
  white-space: pre-wrap; /* Add this line */
`;

export default SystemMessage;
